/**
 * 매장 상세 데이터 조회 및 좋아요 뮤테이션.
 * GET_STORE, GET_PACK, 예약 리뷰 조회, like/cancelLike.
 */
import { useMutation, useQuery } from "@apollo/client";
import { useState } from "react";
import type {
  GetReviewByStoreIdQuery,
  GetReviewByStoreIdQueryVariables,
} from "../../../__generated__/graphql";
import type { TypedDocumentNode } from "@graphql-typed-document-node/core";
import { GET_STORE, GET_PACK } from "../../../api/store-queries";
import { LIKE_STORE, CANCEL_LIKE } from "../../../api/store-mutations";
import { GET_REVIEW_BY_STORE_ID } from "../../../api/store-review-queries";

export function useStorePageData(storeId: number | undefined) {
  const [isStoreDeleted, setIsStoreDeleted] = useState(false);

  const { data, loading, refetch: refetchStore } = useQuery(GET_STORE, {
    variables: { storeId: Number(storeId) },
    fetchPolicy: "network-only",
    skip: !storeId,
    onCompleted: (data) => {
      if (data.store?.isDeleted || data.store?.isHidden) setIsStoreDeleted(true);
    },
  });

  const { data: packData, loading: packLoading } = useQuery(GET_PACK, {
    variables: { storeId: Number(storeId) },
    skip: !storeId,
  });

  const { data: packReviewData } = useQuery<
    GetReviewByStoreIdQuery,
    GetReviewByStoreIdQueryVariables
  >(
    GET_REVIEW_BY_STORE_ID as TypedDocumentNode<
      GetReviewByStoreIdQuery,
      GetReviewByStoreIdQueryVariables
    >,
    {
      variables: {
        storeId: Number(storeId),
        limit: 9,
        offset: 0,
        orderType: "PACK",
      },
      skip: !storeId,
    }
  );

  const [likeStore] = useMutation(LIKE_STORE, {
    refetchQueries: [
      { query: GET_STORE, variables: { storeId: Number(storeId) } },
    ],
  });
  const [cancelLike] = useMutation(CANCEL_LIKE, {
    refetchQueries: [
      { query: GET_STORE, variables: { storeId: Number(storeId) } },
    ],
  });

  const store = data?.store;

  return {
    store,
    packData,
    packReviewData,
    loading,
    packLoading,
    likeStore,
    cancelLike,
    isStoreDeleted,
    setIsStoreDeleted,
    refetchStore,
  };
}
